import React from 'react';
import styles from './WorksGrid.module.css';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const WorkItem = ({ work, index, onItemClick }) => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: '50px'
  });

  const handleClick = () => {
    onItemClick(work);
  };

  // Маппинг типов к иконкам или цветам
  const getTypeLabel = (type) => {
    const typeLabels = {
      'html5': 'HTML5',
      'css': 'CSS3',
      'javascript': 'JavaScript',
      'react': 'React',
      'vue': 'Vue.js',
      'nodejs': 'Node.js'
    };
    return typeLabels[type] || type;
  };

  return (
    <div 
      ref={ref}
      className={styles.workItem}
      style={{ animationDelay: `${index * 100}ms` }}
      onClick={handleClick}
    >
      {isVisible && (
        <>
          <div className={styles.workImageContainer}>
            <img 
              src={work.thumbnail} 
              alt={work.shortTitle}
              className={styles.workImage}
              loading="lazy"
            />
          </div>
          <div className={styles.workInfo}>
            <h3 className={styles.workTitle}>{work.shortTitle}</h3>
            <p className={styles.workDescription}>{work.description}</p>
            <div className={styles.workMeta}>
              <span className={styles.workCategory}>{work.category}</span>
              <span className={styles.workYear}>{work.year}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default WorkItem;